import React from "react";
import { Modal } from "../../../../../../components";

const AddBulkModal = ({ isOpen, onClose }) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Green Card Modal "
      width="max-w-7xl"
    >
      <div>AddBulkModal</div>
    </Modal>
  );
};

export default AddBulkModal;
